if (!customElements.get('anchor-family-compare')) {
  customElements.define(
    'anchor-family-compare',
    class AnchorFamilyCompare extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-anchor-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-anchor-panel]'));
        this.status = this.querySelector('[data-anchor-status]');

        if (!this.tabs.length || this.tabs.length !== this.panels.length) return;

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.show(index, true));
          tab.addEventListener('keydown', (event) => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            let next = index;
            if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            this.show(next, true);
          });
        });

        this.querySelector('[data-anchor-prev]')?.addEventListener('click', () => {
          this.show((this.currentIndex() - 1 + this.tabs.length) % this.tabs.length, true);
        });
        this.querySelector('[data-anchor-next]')?.addEventListener('click', () => {
          this.show((this.currentIndex() + 1) % this.tabs.length, true);
        });

        this.setupSwipe();
        this.show(Math.max(0, this.currentIndex()), false);
      }

      // Sliding between families is the point on a phone, where the arrows are a
      // fallback rather than the primary control. Horizontal intent only, so a
      // vertical page scroll that starts on the panel still scrolls the page.
      setupSwipe() {
        const viewport = this.querySelector('.gf-anchor-compare__viewport');
        if (!viewport || !window.PointerEvent) return;

        let startX = 0;
        let startY = 0;
        let tracking = false;

        viewport.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse') return;
          startX = event.clientX;
          startY = event.clientY;
          tracking = true;
        });

        viewport.addEventListener('pointerup', (event) => {
          if (!tracking) return;
          tracking = false;
          const dx = event.clientX - startX;
          const dy = event.clientY - startY;
          if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
          const step = dx < 0 ? 1 : -1;
          this.show((this.currentIndex() + step + this.tabs.length) % this.tabs.length, false);
        });

        viewport.addEventListener('pointercancel', () => {
          tracking = false;
        });
      }

      currentIndex() {
        return this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
      }

      show(index, focusTab) {
        this.tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });

        this.panels.forEach((panel, panelIndex) => {
          const active = panelIndex === index;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });

        if (this.status) {
          this.status.textContent = `${index + 1} of ${this.tabs.length}: ${this.tabs[index].textContent.trim()}`;
        }
        if (focusTab) this.tabs[index].focus({ preventScroll: true });
      }
    },
  );
}
